const intervalTypes = {
    INT_1m : '1m',
    INT_3m : '3m',
    INT_5m : '5m',
    INT_15m: '15m',
    INT_30m: '30m',
    INT_1h : '1h',
    INT_2h : '2h',
    INT_4h : '4h',
    INT_6h : '6h',
    INT_8h : '8h',
    INT_12h: '12h',
    INT_1d : '1d',
    INT_3d : '3d',
    INT_1w : '1w',
    INT_1M : '1M'
}

const intervalTypesSelect = {
    INT_1m : '1 minuto',
    INT_3m : '3 minutos',
    INT_5m : '5 minutos',
    INT_15m: '15 minutos',
    INT_30m: '30 minutos',
    INT_1h : '1 hora',
    INT_2h : '2 horas',
    INT_4h : '4 horas',
    INT_6h : '6 horas',
    INT_8h : '8 horas',
    INT_12h: '12 horas',
    INT_1d : '1 dia',
    INT_3d : '3 dias',
    INT_1w : '1 semana',
    INT_1M : '1 mês'
}

module.exports = {
    intervalTypes,
    intervalTypesSelect
}
